
import { Bell, Flame } from "lucide-react";
import { Button } from "@/components/ui/button";
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuItem, 
  DropdownMenuTrigger 
} from "@/components/ui/dropdown-menu";
import { useNotifications } from "@/contexts/NotificationContext";
import { format } from "date-fns";

export function NavbarNotifications() {
  const { notifications, unreadCount, markAsRead, markAllAsRead } = useNotifications();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="relative">
          <Bell className="h-5 w-5" />
          {unreadCount > 0 && (
            <span className="absolute top-0 right-0 h-5 w-5 flex items-center justify-center rounded-full bg-red-500 text-white text-[10px] font-medium">
              {unreadCount}
            </span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80">
        <div className="flex justify-between items-center p-2 border-b">
          <h4 className="font-medium">Ειδοποιήσεις</h4>
          {unreadCount > 0 && (
            <Button variant="ghost" size="sm" onClick={markAllAsRead} className="text-xs h-7 px-2">
              Όλα αναγνωσμένα
            </Button>
          )}
        </div>
        <div className="max-h-[300px] overflow-y-auto">
          {notifications.length === 0 ? (
            <div className="p-4 text-center text-muted-foreground">
              Δεν υπάρχουν ειδοποιήσεις
            </div>
          ) : (
            notifications.map((notification) => (
              <DropdownMenuItem key={notification.id} className="p-0">
                <button 
                  className={`w-full text-left p-3 border-b hover:bg-muted/50 transition-colors ${notification.isRead ? 'opacity-75' : 'font-medium'}`}
                  onClick={() => markAsRead(notification.id)}
                >
                  <div className="flex justify-between items-start">
                    <div className="flex flex-col">
                      <div className="flex items-center">
                        {notification.isPremiere && (
                          <Flame className="h-4 w-4 text-red-500 mr-1" />
                        )}
                        <span>{notification.title}</span>
                      </div>
                      <span className="text-xs text-muted-foreground mt-1">
                        {notification.message}
                      </span>
                    </div>
                    <span className="text-[10px] text-muted-foreground">
                      {format(notification.date, 'dd/MM/yy HH:mm')}
                    </span>
                  </div>
                  {!notification.isRead && (
                    <div className="h-2 w-2 bg-primary rounded-full absolute right-3 top-3" />
                  )}
                </button>
              </DropdownMenuItem>
            ))
          )}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
